// extracted by mini-css-extract-plugin
export default {"Secondary":"Weathers_Secondary__AaDG1"};